<template>
  <div>
    <div v-if="view" class="col-md-8 col-md-offset-2">
      <div v-if="this.$store.state.sitecode !== false">
        <h3 class="text-center">
          {{computeCaption(fields_en['personal_data'], this.$store.state.lang.value.toLowerCase())}}
        </h3>
        <br />
        <p v-if="this.$store.state.firstRegistration" class="primary-color text-center">
          {{computeCaption(fields_en['first_registration_disclaimer'], this.$store.state.lang.value.toLowerCase())}}
        </p>
        <MedData type="personalData" ref="medicationData" :triggerWatch="true"> </MedData>
        <br />
        <div class="row">
          <div class="col-md-10 col-md-offset-1 button-container">
            <button
              class="btn btn-default btn-wd btn-back primary-color back-button"
              v-on:click.stop.prevent="
                $router.push({ path: '/patient/account' })
              "
              ><span>
              {{computeCaption(fields_en['back'], this.$store.state.lang.value.toLowerCase())}}
            </span></button
            >
            <button
              class="btn btn-fill btn-wd btn-next float-right next-button"
              v-on:click.stop.prevent="callValidation()"
              ><span>
             {{computeCaption(fields_en['update_data'], this.$store.state.lang.value.toLowerCase())}}
            </span></button
            >
          </div>
        </div>
        <br><br>
      </div>
      <div v-else class="row">
        <div class="col-md-10 col-md-offset-1 bg-white">
          <h3 class="text-center">
            {{computeCaption(fields_en['please_input_your_sitecode'], this.$store.state.lang.value.toLowerCase())}}
          </h3>
          <br />
          <div class="pb-5" :class="[validatedSectionClass, generalClass]">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="sitecode" class="control-label required">
                  {{computeCaption(fields_en['office_location_code'], this.$store.state.lang.value.toLowerCase())}}
                </label>
                <input
                  type="text"
                  name="sitecode"
                  id="sitecode"
                  ref="sitecode"
                  data-vv-as="Sitecode"
                  v-model="sitecode"
                  class="form-control"
                  placeholder="ex: 12345"
                />
                <small class="text-danger" v-show="sitecodeError">
                  {{sitecodeError && computeCaption(sitecodeError, this.$store.state.lang.value.toLowerCase())}}
                </small>
              </div>
              <small class="text-danger" v-show="errorSave">
                {{errorSave && computeCaption(errorSave, this.$store.state.lang.value.toLowerCase())}}
              </small>
            </div>
          </div>
          </div>
          <br>
          <div class="row padding-bottom button-container">
            <div class="col-md-5">
              <button
                class="btn btn-default btn-wd btn-back primary-color back-button"
                v-on:click.stop.prevent="
                  $router.push({ path: '/patient/account' })
                "
                ><span>
               {{computeCaption(fields_en['back'], this.$store.state.lang.value.toLowerCase())}}
              </span></button
              >
            </div>
            <div class="col-md-7">
              <button
                class="btn btn-fill btn-wd btn-next float-right next-button"
                v-on:click.stop.prevent="validateSiteCode()"
                ><span>
               {{computeCaption(fields_en['update_data'], this.$store.state.lang.value.toLowerCase())}}
              </span></button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else v-loading.fullscreen.lock="!view" class="loading"></div>
  </div>
</template>
<script>
  import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Address from '../../Utils/Sections/Address'
  import MedData from './MedDataRegistration'
  import swal from 'sweetalert2'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  require('cleave.js/dist/addons/cleave-phone.us')
  export default {
    components: {
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      Address,
      MedData
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
    data () {
      return {
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        insuredAddressInitial: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        },
        view: false,
        errorSave: '',
        address_error: '',
        questionError: '',
        phoneTransaction: false,
        drawer: false,
        dateScanned: false,
        allow_user_demo: this.$store.state.configs.ALLOW_USER_DEMO,
        suggestions: [],
        smartystreets_key: this.$store.state.configs.SMARTYSTREETS_KEY,
        answers_es: {},
        answers_zh: {},
        requirements: [],
        errorDate: '',
        questionErrorDate: [],
        answer_no: 'No',
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        fields_en: {
          personal_data: 'Personal Data',
          back: 'Back',
          update_data: 'Update Data',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required',
          office_location_code: 'Office Location Code',
          please_input_your_sitecode: 'Please fill in your Site Code',
          first_registration_disclaimer: 'We have seen that you already have a registration on this email address. Make sure that this is the correct data and press "Update data"'
        },
        sitecode: '',
        sitecodeError: ''
      }
    },
    methods: {
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validateSiteCode () {
        if (this.sitecodeError === '') {
          await axios.post(process.env.SERVER_URI + '/account/add/sitecode', {'email': localStorage.getItem('email'), 'code': this.sitecode}, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
            .then((response) => {
              if (response.data === false) {
                this.errorSave = 'There was an error submitting the data'
              } else {
                if (this.$store.state.configs.SKIP_FIRST_REGISTRATION === true && this.$store.state.configs.SKIP_FIRST_REGISTRATION !== undefined) {
                  this.$store.state.sitecode = this.sitecode
                  this.$router.push({path: '/patient/account'})
                  return
                }
                let one = process.env.SERVER_URI + '/requirements/' + this.sitecode
                let four = process.env.SERVER_URI + '/ethnicity/' + this.sitecode
                let five = process.env.SERVER_URI + '/race/' + this.sitecode
                let six = process.env.SERVER_URI + '/gender/' + this.sitecode
                let two = process.env.SERVER_URI + '/insurance/' + this.sitecode
                let three = process.env.SERVER_URI + '/account/check/user'
                let email = localStorage.getItem('email')
                const requestOne = axios.get(one)
                const requestFour = axios.get(four)
                const requestFive = axios.get(five)
                const requestSix = axios.get(six)
                const requestTwo = axios.get(two)
                const requestThree = axios.post(three, {'email': email}, {
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                })
                axios.all([requestOne, requestFour, requestFive, requestSix, requestTwo, requestThree])
              .then(axios.spread((...responses) => {
                this.$store.state.requirements = {...this.$store.state.requirements, ...responses[0].data}
                this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
                this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
                this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
                this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
                this.$store.state.ethnicity = responses[1].data
                this.$store.state.race = responses[2].data
                this.$store.state.gender = responses[3].data
                this.$store.state.insurance = responses[4].data
                if (responses[5].data === false) {
                  this.$store.state.userData = {
                    driver_license_image: '',
                    driver_license_name: '',
                    firstName: '',
                    lastName: '',
                    passport: '',
                    dob: '',
                    dob_pretty: '',
                    address: '',
                    address2: '',
                    gender: '',
                    phone: '',
                    race: '',
                    ethnicity: '',
                    addressComponents: '',
                    primary_insurance: '',
                    policy_number: '',
                    group_number: '',
                    driver_license_number: '',
                    social_number: '',
                    insured_first_name: '',
                    insured_middle_name: '',
                    insured_last_name: '',
                    insured_gender: '',
                    insured_date_of_birth: '',
                    insured_date_of_birth_pretty: '',
                    insured_address_components: '',
                    insured_address: '',
                    relationship: ''
                  }
                } else if (responses[5].data) {
                  let addressInitial = {}
                  if (responses[5].data['addressComponents']) {
                    addressInitial = {
                      name: responses[5].data['addressComponents']['name'] || '',
                      original_name: responses[5].data['addressComponents']['original_name'] || '',
                      delivery_line_1: responses[5].data['addressComponents']['delivery_line_1'] || '',
                      city_name: responses[5].data['addressComponents']['city_name'] || '',
                      county: responses[5].data['addressComponents']['county'] || '',
                      state_abbreviation: responses[5].data['addressComponents']['state_abbreviation'] || '',
                      zipcode: responses[5].data['addressComponents']['zipcode'] || '',
                      plus4_code: responses[5].data['addressComponents']['plus4_code'] || '',
                      county_fips: responses[5].data['addressComponents']['county_fips'] || '',
                      country: responses[5].data['addressComponents']['country'] || ''
                    }
                  }
                  let insuredAddressInitial = {}
                  if (responses[5].data['insured_address_components']) {
                    insuredAddressInitial = {
                      name: responses[5].data['insured_address_components']['name'] || '',
                      original_name: responses[5].data['insured_address_components']['original_name'] || '',
                      delivery_line_1: responses[5].data['insured_address_components']['delivery_line_1'] || '',
                      city_name: responses[5].data['insured_address_components']['city_name'] || '',
                      county: responses[5].data['insured_address_components']['county'] || '',
                      state_abbreviation: responses[5].data['insured_address_components']['state_abbreviation'] || '',
                      zipcode: responses[5].data['insured_address_components']['zipcode'] || '',
                      plus4_code: responses[5].data['insured_address_components']['plus4_code'] || '',
                      county_fips: responses[5].data['insured_address_components']['county_fips'] || '',
                      country: responses[5].data['insured_address_components']['country'] || ''
                    }
                  }
                  this.$store.state.userData = {
                    firstName: responses[5].data['first_name'] || '',
                    middleName: responses[5].data['middle_name'] || '',
                    lastName: responses[5].data['last_name'] || '',
                    passport: responses[5].data['passport'] || '',
                    dob: responses[5].data['date_of_birth'] || '',
                    dob_pretty: responses[5].data['date_of_birth'] || '',
                    address: responses[5].data['address'] || '',
                    address2: responses[5].data['address2'] || '',
                    gender: responses[5].data['gender'] || '',
                    phone: responses[5].data['phone'] || '',
                    race: responses[5].data['race'] || '',
                    ethnicity: responses[5].data['ethnicity'] || '',
                    addressComponents: addressInitial,
                    primary_insurance: responses[5].data['insurance_name'] || '',
                    policy_number: responses[5].data['policy_number'] || '',
                    group_number: responses[5].data['group_number'] || '',
                    driver_license_number: responses[5].data['driver_license_number'] || '',
                    social_number: responses[5].data['social_number'] || '',
                    insured_first_name: responses[5].data['insured_first_name'] || '',
                    insured_last_name: responses[5].data['insured_last_name'] || '',
                    insured_middle_name: responses[5].data['insured_middle_name'] || '',
                    insured_gender: responses[5].data['insured_gender'] || '',
                    insured_date_of_birth: responses[5].data['insured_date_of_birth'] || '',
                    insured_date_of_birth_pretty: responses[5].data['insured_date_of_birth'] || '',
                    insured_address_components: insuredAddressInitial,
                    insured_address: responses[5].data['insured_address'] || '',
                    insured_address2: responses[5].data['insured_address2'] || '',
                    relationship: responses[5].data['relationship'] || ''
                  }
                }
                this.$store.state.sitecode = this.sitecode
                let one = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
                const requestOne = axios.get(one)
                axios.all([requestOne]).then((axios.spread((...responses) => {
                  this.$store.state.site = responses[0].data
                  if (responses[0].data['restrict_email_to_domain']) {
                    this.$store.state.restrict_email_to_domain = responses[0].data['restrict_email_to_domain']
                  }
                  let restrictEmail = this.$store.state.restrict_email_to_domain || ''
                  if (restrictEmail !== '') {
                    if (!email.endsWith('@' + this.restrictEmail)) {
                      this.$store.state.sitecode = ''
                      axios({
                        url: process.env.SERVER_URI + '/account/delete/account',
                        method: 'post',
                        data: {access_token: localStorage.getItem('access_token'), email: localStorage.getItem('email')},
                        headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}
                      })
                        .then((response) => {
                          localStorage.clear()
                          swal('Invalid Email Domain!', 'Your Office Location has email domain restrictions. Your email address does not comply so this account has successfully been deleted!', 'error')
                          this.redirectHome()
                        })
                        .catch(function (error) {
                          console.log(error)
                        })
                    }
                  }
                })))
              }))
              }
            }).catch(error => {
              console.log(error)
              this.errorSave = 'There was an error submitting the data'
            })
        }
      },
      redirectHome () {
        const body = document.querySelector('body')
        const self = this
        body.onclick = function () {
          self.$router.push({ path: '/' })
          window.location.reload()
        }
      },
      async callValidation () {
        await this.$refs.medicationData.validate()
        if (this.$store.state.medDataValidator) {
          this.$router.push({path: '/patient/account'})
          this.$store.state.firstRegistration = false
          this.$store.state.medDataValidator = false
        }
      },
      async prepareData () {
        if (this.$store.state.sitecode !== false) {
          let one = process.env.SERVER_URI + '/requirements/' + this.$store.state.sitecode
          let four = process.env.SERVER_URI + '/ethnicity/' + this.$store.state.sitecode
          let five = process.env.SERVER_URI + '/race/' + this.$store.state.sitecode
          let six = process.env.SERVER_URI + '/gender/' + this.$store.state.sitecode
          let two = process.env.SERVER_URI + '/insurance/' + this.$store.state.sitecode
          let three = process.env.SERVER_URI + '/account/check/user'
          let seven = process.env.SERVER_URI + '/validate/site/' + this.$store.state.sitecode
          let email = localStorage.getItem('email')
          const requestOne = axios.get(one)
          const requestFour = axios.get(four)
          const requestFive = axios.get(five)
          const requestSix = axios.get(six)
          const requestTwo = axios.get(two)
          const requestSeven = axios.get(seven)
          const requestThree = axios.post(three, {'email': email}, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          await axios.all([requestOne, requestFour, requestFive, requestSix, requestTwo, requestThree, requestSeven])
              .then(axios.spread((...responses) => {
                this.$store.state.requirements = {...this.$store.state.requirements, ...responses[0].data}
                this.$store.state.configs.ALLOW_DRIVER_LICENSE = this.$store.state.requirements.driver_license_image && this.$store.state.requirements.driver_license_image !== ''
                this.$store.state.configs.REQUIRED_DRIVER_LICENSE = this.checkRequirement('driver_license_image')
                this.$store.state.configs.ALLOW_INSURANCE_CARD = this.$store.state.requirements.insurance_card_image && this.$store.state.requirements.insurance_card_image !== ''
                this.$store.state.configs.REQUIRED_INSURANCE_CARD = this.checkRequirement('insurance_card_image')
                this.$store.state.ethnicity = responses[1].data
                this.$store.state.race = responses[2].data
                this.$store.state.gender = responses[3].data
                this.$store.state.insurance = responses[4].data
                if (responses[5].data === false) {
                  this.$store.state.userData = {
                    driver_license_image: '',
                    driver_license_name: '',
                    firstName: '',
                    lastName: '',
                    passport: '',
                    dob: '',
                    dob_pretty: '',
                    address: '',
                    address2: '',
                    gender: '',
                    phone: '',
                    race: '',
                    ethnicity: '',
                    addressComponents: '',
                    primary_insurance: '',
                    policy_number: '',
                    group_number: '',
                    driver_license_number: '',
                    social_number: '',
                    insured_first_name: '',
                    insured_middle_name: '',
                    insured_last_name: '',
                    insured_gender: '',
                    insured_date_of_birth: '',
                    insured_date_of_birth_pretty: '',
                    insured_address_components: '',
                    insured_address: '',
                    relationship: ''
                  }
                } else if (responses[5].data) {
                  let addressInitial = {}
                  if (responses[5].data['addressComponents']) {
                    addressInitial = {
                      name: responses[5].data['addressComponents']['name'] || '',
                      original_name: responses[5].data['addressComponents']['original_name'] || '',
                      delivery_line_1: responses[5].data['addressComponents']['delivery_line_1'] || '',
                      city_name: responses[5].data['addressComponents']['city_name'] || '',
                      county: responses[5].data['addressComponents']['county'] || '',
                      state_abbreviation: responses[5].data['addressComponents']['state_abbreviation'] || '',
                      zipcode: responses[5].data['addressComponents']['zipcode'] || '',
                      plus4_code: responses[5].data['addressComponents']['plus4_code'] || '',
                      county_fips: responses[5].data['addressComponents']['county_fips'] || '',
                      country: responses[5].data['addressComponents']['country'] || ''
                    }
                  }
                  let insuredAddressInitial = {}
                  if (responses[5].data['insured_address_components']) {
                    insuredAddressInitial = {
                      name: responses[5].data['insured_address_components']['name'] || '',
                      original_name: responses[5].data['insured_address_components']['original_name'] || '',
                      delivery_line_1: responses[5].data['insured_address_components']['delivery_line_1'] || '',
                      city_name: responses[5].data['insured_address_components']['city_name'] || '',
                      county: responses[5].data['insured_address_components']['county'] || '',
                      state_abbreviation: responses[5].data['insured_address_components']['state_abbreviation'] || '',
                      zipcode: responses[5].data['insured_address_components']['zipcode'] || '',
                      plus4_code: responses[5].data['insured_address_components']['plus4_code'] || '',
                      county_fips: responses[5].data['insured_address_components']['county_fips'] || '',
                      country: responses[5].data['insured_address_components']['country'] || ''
                    }
                  }
                  this.$store.state.userData = {
                    firstName: responses[5].data['first_name'] || '',
                    lastName: responses[5].data['last_name'] || '',
                    middleName: responses[5].data['middle_name'] || '',
                    suffix: responses[5].data['suffix'] || '',
                    passport: responses[5].data['passport'] || '',
                    dob: responses[5].data['date_of_birth'] || '',
                    dob_pretty: responses[5].data['date_of_birth'] || '',
                    address: responses[5].data['address'] || '',
                    address2: responses[5].data['address2'] || '',
                    gender: responses[5].data['gender'] || '',
                    phone: responses[5].data['phone'] || '',
                    race: responses[5].data['race'] || '',
                    ethnicity: responses[5].data['ethnicity'] || '',
                    addressComponents: addressInitial,
                    primary_insurance: responses[5].data['insurance_name'] || '',
                    policy_number: responses[5].data['policy_number'] || '',
                    group_number: responses[5].data['group_number'] || '',
                    driver_license_number: responses[5].data['driver_license_number'] || '',
                    social_number: responses[5].data['social_number'] || '',
                    insured_first_name: responses[5].data['insured_first_name'] || '',
                    insured_middle_name: responses[5].data['insured_middle_name'] || '',
                    insured_last_name: responses[5].data['insured_last_name'] || '',
                    insured_gender: responses[5].data['insured_gender'] || '',
                    insured_date_of_birth: responses[5].data['insured_date_of_birth'] || '',
                    insured_date_of_birth_pretty: responses[5].data['insured_date_of_birth'] || '',
                    insured_address_components: insuredAddressInitial,
                    insured_address: responses[5].data['insured_address'] || '',
                    insured_address2: responses[5].data['insured_address2'] || '',
                    relationship: responses[5].data['relationship'] || ''
                  }
                }
                if (responses[6].data === false) {
                  this.view = false
                } else {
                  this.$store.state.site = responses[6].data
                  this.overwriteGraphSettings(responses[6].data)
                }
                this.view = true
              })).catch(error => {
                console.log(error)
                this.view = false
              })
        } else {
          this.view = true
          this.$store.state.sitecode = false
        }
      }
    },
    async beforeMount () {
      await this.prepareData()
    },
    watch: {
      'sitecode': {
        handler: function (after, before) {
          if (this.sitecode.length >= 2 && /\S/.test(this.sitecode)) {
            this.sitecodeError = ''
            this.validatedSectionClass = 'validated-section-class'
            this.generalClass = 'general-inactive-section'
          } else {
            this.sitecodeError = 'Site Code should be at least 2 characters long'
            this.validatedSectionClass = 'invalid-section-class'
            this.generalClass = 'general-invalid-section'
          }
        }
      },
      '$store.state.medDataValidator': {
        handler: function (after, before) {
          this.$router.push({path: '/patient/account'})
          this.$store.state.medDataValidator = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

.el-select--large {
  width: 100%;
}

.el-autocomplete {
  width: 100%;
}

h4 {
  margin-bottom: 10px;
  font-weight: normal;
}

.loading-size {
  font-size: 70px;
  color: $primary-color !important;
}

.display-none {
  display: none;
}

.generic-answer {
  margin-top: 10px;
}

.float-right {
  float: right;
}

.p-0 {
  padding: 0;
}

.w-100 {
  width: 100% !important;
}

.pr-0 {
  padding-right: 0;
}

.p-10 {
  padding: 10px;
}
.padding-bottom {
  padding-bottom: 20px;
}
.pb-5 {
    padding-bottom: 5px;
  }

@media screen and (max-width: 991px) {
  .pr-0 {
    padding-left: 0;
  }
}

.pt-10 {
  padding-top: 10px;
}

.line-clamp {
  text-overflow: ellipsis;
  overflow: hidden;
  /* width: 500px; */
  height: 1.2em;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.d-inline-block {
  display: inline-block;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.upload-file {
  width: 0;
  height: 0;
}

.upload-file-label {
  display: block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
}

.bg-white {
  background: white;
}

.elipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  height: 1.2em;
  white-space: nowrap;
}

.text-none {
  text-transform: none;
  font-size: 14px;
}
.button {
  width: 30% !important;
  min-width: 120px;
  float: right;
  background: $primary-color !important;
  color: white;
  border-radius: 5px;
  &:hover {
    color: white !important;
  }
  &:focus {
    color: white !important;
  }
}
.button-back {
  width: 100px !important;
  background: white !important;
  color: $secondary-color;
  border-radius: 5px;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

@media screen and (max-width: 991px) {
  .mt-5 {
    margin-top: 0;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .button {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}

@media screen and (max-width: 365px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 7px;
  }
  .button {
    float: left;
    width: 100% !important;
  }
  .button-back {
    margin-bottom: 2px;
    float: left;
    width: 100% !important;
  }
}
@media screen and (max-width: 420px) {
  .button-container {
    display: grid;
  }
  .button-container > .back-button{
    grid-row: 2 !important;
  }
  .button-container > .next-button{
    grid-row: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/PersonalData.vue